import React, { useState, useEffect } from 'react'; // Ensure useEffect is imported
import HeaderMobile from './HeaderMobile.js';
import Header from './Header.js';
import Sidebar from './Sidebar.js';
import './Add_User.css';
import Footer from './Footer.js';  // Import Footer component
import { useNavigate, useParams } from 'react-router-dom'; // useParams to get the dynamic id
import { BASE_URL } from "./Constants.js";

const Get_DressColor = () => {
  const [newUser, setNewUser] = useState({
    dress_color: '',
    dress_size_id: '',
    dress_type_id: ''
  });
  const [formError, setFormError] = useState(null);
  const navigate = useNavigate(); // Use navigate hook
  const [dressTypes, setDressTypes] = useState([]);
  const { id } = useParams(); // Get dynamic id from the URL
  const [dressSizes, setDressSizes] = useState([]); // State to store dress types
  const [user, setUser] = useState(null);  // To store the user data (isAdmin or similar)
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [error, setError] = useState(null); // To store error message if any
  const [loading, setLoading] = useState(true); // To manage loading state

  // Fetch user profile using useEffect
  useEffect(() => {
    const token = localStorage.getItem('authToken');
    console.log(token); // for debugging
    const fetchProfile = async () => {
      try {
        const response = await fetch(`${BASE_URL}profile`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        });

        const data = await response.json();
        setUser(data.profile.is_uniform_access_given); // Assuming the response contains the user profile info
      } catch (error) {
        setError(error.message); // Handle errors
        console.error('Error fetching profile:', error);
      } finally {
        setLoading(false); // Set loading to false after data fetch completes
      }
    };

    fetchProfile();
  }, []);  // Empty dependency array to run this effect only once on component mount

useEffect(() => {
    const fetchDressTypes = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_types`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        console.log('Fetched dress types:', data);

        if (data && data.dressTypes && Array.isArray(data.dressTypes)) {
          // Filter out dress types with status 'A'
          const activeDressTypes = data.dressTypes.filter(type => type.status === 'A');
          setDressTypes(activeDressTypes); // Set active dress types
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchDressTypes();
  }, []); // Only runs once when the component mounts
  // Fetch dress type data based on ID when the component mo

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const token = localStorage.getItem('authToken');
        console.log(token);

        // If no token is found, handle the error
        if (!token) {
          setError('No token found!');
          setLoading(false);
          return;
        }

        const response = await fetch(`${BASE_URL}dress_sizes`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`,
          },
        });

        const data = await response.json();
        console.log('Fetched data:', data);
        if (data && data.dressSizes && Array.isArray(data.dressSizes)) {
          // Filter out users with status 'A'
          const activeDressSizes = data.dressSizes.filter(user => user.status === 'A');
          setDressSizes(activeDressSizes);
        }
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchUsers();
  }, []); // Only runs once when the component mounts


  // Fetch dress type data based on ID when the component mounts
  useEffect(() => {
    const fetchDressType = async () => {
      try {
        const token = localStorage.getItem('authToken');
        const response = await fetch(`${BASE_URL}get_dress_colors/${id}`, {
          method: 'GET',
          headers: {
            'Authorization': `Bearer ${token}`,
          },
        });

        if (!response.ok) {
          throw new Error('Failed to fetch dress size');
        }

        const data = await response.json();
        // Use a functional update to avoid relying on newUser in the dependency array
        setNewUser(prevState => ({
          ...prevState,
          dress_color: data.dressColor.dress_color || '',
          dress_size_id: data.dressColor.dress_size_id || '',
          dress_type_id: data.dressColor.dress_type_id || '',
          gender: data.dressColor.gender
        }));
      } catch (err) {
        setFormError(err.message);
      }
    };

    fetchDressType();
  }, [id]); // Only depend on id, not newUser

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewUser((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Simple form validation
    if (!newUser.dress_color) {
      setFormError('field are required.');
      return;
    }

    try {
      const token = localStorage.getItem('authToken');
      const formData = new FormData();
      formData.append('dress_color', newUser.dress_color);

      formData.append('dress_size_id', newUser.dress_size_id);
      formData.append('dress_type_id', newUser.dress_type_id);
      formData.append('gender', newUser.gender);


      const response = await fetch(`${BASE_URL}update_dress_colors/${id}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        body: formData,
      });

      if (!response.status) {
        throw new Error('Failed to add dress color');
      }

      // Redirect to the Manage User page after successful submission
      navigate('/manage_dresscolor'); // You can modify this route if needed

    } catch (err) {
      setFormError(err.message);
    }
  };

  const handleToggleSidebar = () => {
    if (window.innerWidth >= 992) {
      setIsSidebarOpen(prev => !prev);
    }
  };

  const handleCancel = () => {
    navigate('/manage_dresscolor');
  }

  return (
    <div className="page-wrapper">
      <HeaderMobile />
      <Sidebar isOpen={isSidebarOpen} />
      <div className="page-container" style={{
        marginLeft: isSidebarOpen && window.innerWidth >= 992 ? '300px' : '0',
        transition: 'margin-left 0.3s ease',

      }}>
        <Header onToggleSidebar={handleToggleSidebar} isSidebarOpen={isSidebarOpen} />
        <div className="main-content">
          <div className="section__content section__content--p30">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-6 offset-lg-3">
                  {/* Add User Card */}
                  <div className="card add-user-card">
                    <div className="card-header">
                      <h2>Edit Dress Color</h2>
                    </div>
                    <div className="card-body">
                      {/* Add User Form */}
                      <form onSubmit={handleSubmit}>
                        {formError && <div className="alert alert-danger">{formError}</div>}

                        <div className='form-group'>
                          <label>Gender</label>
                          <select
                            name="gender"
                            value={newUser.gender}
                            onChange={handleInputChange}
                            className='form-control'
                            required
                          >
                            <option value="">Select Gender</option>
                            <option value="Male">Male</option>
                            <option value="Female">Female</option>
                          </select>
                        </div>

                        <div className="form-group">
                          <label>Dress Type</label>
                          <select
                            name="dress_type_id"
                            className="form-control"
                            value={newUser.dress_type_id}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select Type</option>
                            {dressTypes.map((type) => (
                              <option key={type.id} value={type.id}>{type.dress_type}</option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group">
                          <label>Dress Size</label>
                          <select
                            name="dress_size_id"
                            className="form-control"
                            value={newUser.dress_size_id}
                            onChange={handleInputChange}
                            required
                          >
                            <option value="">Select Size</option>
                            {dressSizes.map((item) => (
                              <option key={item.id} value={item.id}>
                                {item.dress_size}
                              </option>
                            ))}
                          </select>
                        </div>

                        <div className="form-group">
                          <label htmlFor="dress_color">Dress Color</label>
                          <input
                            type="text"
                            id="dress_color"
                            name="dress_color"
                            className="form-control"
                            value={newUser.dress_color}
                            onChange={handleInputChange}
                          />
                        </div>
                        <div style={{ display: 'flex', gap: '10px' }}>
                          <button type="submit" className="btn btn-primary">
                            Submit
                          </button>
                          <button type="button" className="btn btn-secondary" onClick={handleCancel}>
                            Cancel
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Footer /> {/* Footer will stick to the bottom */}
      </div>
    </div>
  );
};

export default Get_DressColor;
